import Vue from 'vue'
import AsyncStreamsExecutor from '../modules/AsyncStreamExecutor'

export default function () {
  const asyncExecutor = new AsyncStreamsExecutor({ count: 2 })
  Object.defineProperties(Vue.prototype, {
    $asyncExecutor: {
      get () {
        return asyncExecutor
      }
    }
  })
}
